function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fillRule: "nonzero",
  d: "M1 0h12v12H1z"
}), React.createElement("path", {
  fill: "#595959",
  fillRule: "nonzero",
  d: "M11.978 5.6A5.998 5.998 0 0 0 6.392.014V0h-.8v.014A6 6 0 0 0 .006 5.6h-.014v.8h.014a5.998 5.998 0 0 0 5.586 5.586V12h.8v-.014A5.998 5.998 0 0 0 11.978 6.4h.014v-.8h-.014zm-8.23-4.292c-.386.514-.707 1.158-.94 1.892h-1.2a5.227 5.227 0 0 1 2.14-1.892zM1.19 4h1.407A9.5 9.5 0 0 0 2.4 5.6H.807A5.155 5.155 0 0 1 1.19 4zM.807 6.4H2.4A9.5 9.5 0 0 0 2.597 8H1.19a5.155 5.155 0 0 1-.383-1.6zm.802 2.4h1.197c.234.734.555 1.378.942 1.892A5.222 5.222 0 0 1 1.608 8.8zm3.983 2.349c-.822-.22-1.53-1.103-1.96-2.349h1.96v2.349zm0-3.149H3.407A8.941 8.941 0 0 1 3.2 6.4h2.392V8zm0-2.4H3.2A8.941 8.941 0 0 1 3.407 4h2.185v1.6zm0-2.4h-1.96c.43-1.246 1.138-2.129 1.96-2.348V3.2zm4.783 0H9.178c-.234-.734-.554-1.378-.942-1.892a5.232 5.232 0 0 1 2.14 1.892zM6.392.852c.822.22 1.53 1.102 1.96 2.348h-1.96V.852zm0 3.148h2.184c.114.498.183 1.037.208 1.6H6.392V4zm0 2.4h2.392A8.868 8.868 0 0 1 8.576 8H6.392V6.4zm0 4.749V8.8h1.96c-.43 1.246-1.138 2.129-1.96 2.349zm1.844-.457c.386-.514.708-1.158.942-1.892h1.197a5.227 5.227 0 0 1-2.139 1.892zM10.794 8H9.387a9.5 9.5 0 0 0 .197-1.6h1.592a5.132 5.132 0 0 1-.382 1.6zm-1.21-2.4A9.5 9.5 0 0 0 9.387 4h1.407c.208.498.34 1.037.383 1.6H9.584z"
}));

var SvgIcNation = function SvgIcNation(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcNation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-nation.7e57e4bb.svg";
export { ForwardRef as ReactComponent };